export default "__VITE_ASSET__DUaU81c1__";